import { LinearProgress } from "@clockwise/design-system";
import React from "react";

export const LoadingProgress = () => (
  <div className="cw-h-1 cw-bg-positive-emphasis">
    <LinearProgress className="cw-h-1" />
  </div>
);
